import React from 'react';
import PropTypes from 'prop-types';

const BedlinenTowelsNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.348 17.652H5.913a1.304 1.304 0 1 0 0 2.609h10.435a2.174 2.174 0 1 0 0-4.348H5.043a3.043 3.043 0 1 0 0 6.087h13.913a3.041 3.041 0 0 0 2.813-4.208 3.043 3.043 0 0 0-2.813-1.879h-2.608"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 18.956 19.844 4.95A3.477 3.477 0 0 0 16.407 2H7.593a3.476 3.476 0 0 0-3.437 2.95L2 18.956"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

BedlinenTowelsNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default BedlinenTowelsNot;
